import { createQueryStringToggleHook } from "../../../../../stores/useQueryState";

export const useSpeedIndexParamName = "speed";

export const useSpeedIndex = createQueryStringToggleHook(
  useSpeedIndexParamName,
  []
);
